import { useEffect, useState } from "react";
import { listPartnerSources } from "../../api/partnerApi";
import RequirePermission from "../../auth/RequirePermission";
import StatusBadge from "../../components/midpoint/intelligence/StatusBadge";
import { formatDateTime } from "../../components/midpoint/admin/users/adminUserFormatters";

function PartnerSourcesContent() {
  const [sources, setSources] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setIsLoading(true);
        const body = await listPartnerSources();
        if (!cancelled) {
          setSources(body.sources || []);
        }
      } catch (error) {
        if (!cancelled) {
          setErrorMessage(error.message || "Unable to load sources.");
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="panel-card">
      <h2>Sources</h2>
      <p className="muted admin-users-help">
        Operational status only. Scraper configuration and credentials are not shown.
      </p>

      {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}
      {isLoading ? <p className="muted">Loading…</p> : null}

      {!isLoading && sources.length ? (
        <table className="admin-data-health-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Enabled</th>
              <th>Last run</th>
              <th>Status</th>
              <th>Listings</th>
            </tr>
          </thead>
          <tbody>
            {sources.map((source) => (
              <tr key={source.sourceId}>
                <td>{source.displayName}</td>
                <td>{source.sourceKey}</td>
                <td>
                  <StatusBadge
                    label={source.enabled ? "Yes" : "No"}
                    tone={source.enabled ? "confirmed" : "disputed"}
                  />
                </td>
                <td>{formatDateTime(source.lastRunAt)}</td>
                <td>{source.lastStatus || "—"}</td>
                <td>{source.listingCount ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}

      {!isLoading && !sources.length && !errorMessage ? (
        <p className="muted">No sources in your partner scope.</p>
      ) : null}
    </section>
  );
}

const PartnerSourcesPage = () => (
  <RequirePermission permission="partner_sources.view">
    <PartnerSourcesContent />
  </RequirePermission>
);

export default PartnerSourcesPage;
